export const SET_TOKEN = 'SET_TOKEN' //添加token
export const OUT_LOGIN = 'OUT_LOGIN' //退出登录
export const SET_USERINFO = 'SET_USERINFO' //设置个人信息
export const SET_MODIFIER = 'SET_MODIFIER' //设置中间修饰 5" 3"
export const SET_PARAMDATA = 'SET_PARAMDATA'